import { render } from "./CertificatesSuccess.vue?vue&type=template&id=64d2381b"
import script from "./CertificatesSuccess.vue?vue&type=script&lang=js"
export * from "./CertificatesSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__